import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { StyleSheet, css } from 'aphrodite';
import Navbar from '../components/navbar.component';
import { RoutePlaceholder } from '../components/pagePlaceholder.component';
import { selectHasAdminAccess } from '../store/sessionSelectors';
import { AppFooter } from './AppFooter';
import { AppRoutes } from './AppRoutes';
import { useAuthBootstrap } from './useAuthBootstrap';

export function AppShell() {
  const hasAdminAccess = useSelector(selectHasAdminAccess);

  useAuthBootstrap();

  return (
    <div className={css(styles.shell)}>
      <Navbar defaultAction="Buy Jewelleries">
        <Navbar.Actions label="Home" />
        <Navbar.Actions label="Buy Jewelleries" />
        <Navbar.Actions label="Services" />
        <Navbar.Actions label="Contact Us" />
        <Navbar.Actions label="Gold Rush" />
        {hasAdminAccess && (
          <Navbar.Actions label="Admin" />
        )}
      </Navbar>
      <main className={css(styles.content)}>
        <Suspense fallback={<RoutePlaceholder />}>
          <AppRoutes />
        </Suspense>
      </main>
      <AppFooter />
    </div>
  );
}

const styles = StyleSheet.create({
  // Keeps the footer at the bottom of the screen on pages shorter than it.
  shell: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  content: {
    flex: 1,
  },
});
